import { normalize, schema } from 'normalizr';

import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'gatewayConfig';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'gatewayConfigID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);

// Gateway Transformers
export const { transformer, listTransformer } = createRetailTransformers('GatewayConfig');
